module.exports = __webpack_public_path__ + "img/cart-on.f4ceb74b.png";